<script setup lang="ts">
import { AxiosInstance } from 'axios'
import { useVueInject } from '@/hooks/vue'
import { pluginKeys } from '@/plugins/axios'
import { QuestionsStoreKey, QuestionsStore } from '@/stores/common/questions'
import { provide } from 'vue'

provide(QuestionsStoreKey, new QuestionsStore(useVueInject<AxiosInstance>(pluginKeys.AXIOS)))
</script>

<template>
  <router-view />
</template>
